import merge from 'lodash/merge'
import isEqual from 'lodash/isEqual'

import { capitalize, objectFilter, toObject } from '@converdy/utils'

import splitBreakpoints from '../split-breakpoints'

function parseBorder ({
  all,
  top,
  right,
  bottom,
  left,
  radius
}) {
  let jss = {}

  if (all) {
    if (all.width) { jss.borderWidth = `${all.width.value}${all.width.unit}` }

    if (all.style) { jss.borderStyle = all.style }

    if (all.color) { jss.borderColor = all.color }
  }

  const divergingBorders = objectFilter(
    border => !isEqual(all, border)
  )(
    { top, right, bottom, left }
  )

  jss = merge(
    jss,
    Object.entries(divergingBorders).reduce(
      (individualBordersJss, [ key, { width, style = 'solid', color } ]) => {
        const individualBorderJss = {}

        if (width) { individualBorderJss[ `border${capitalize(key)}Width` ] = `${width.value}${width.unit}` }

        if (style) { individualBorderJss[ `border${capitalize(key)}Style` ] = style }

        if (color) { individualBorderJss[ `border${capitalize(key)}Color` ] = color }

        return {
          ...individualBordersJss,
          ...individualBorderJss
        }
      },
      {}
    )
  )

  if (!radius) { return jss }

  const borderRadiuses = [
    { name: 'border-top-left-radius', value: radius.topleft },
    { name: 'border-top-right-radius', value: radius.topright },
    { name: 'border-bottom-right-radius', value: radius.bottomright },
    { name: 'border-bottom-left-radius', value: radius.bottomleft },
  ]

  return merge(
    jss,
    toObject(
      ({ name }) => name,
      ({ value }) => value.value + value.unit
    )(borderRadiuses.filter(({ value }) => Boolean(value) ))
  )
}

export default splitBreakpoints(parseBorder)
